import { GripVertical } from "lucide-react";
import { observer } from "mobx-react-lite";

import { usePlayground } from "@/components/Playground/playground-store";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { usePlaceholderContainer } from "@/components/Playground/Messages/PlaceholderContainer/context/placeholder-container-context";

export const PlaceholderContainerHeaderDragHandle = observer(() => {
  const playground = usePlayground();
  const { index, readonly, dragHandleProps } = usePlaceholderContainer();

  if (readonly || playground.isAIPromptAssistantLoading) {
    return null;
  }

  return (
    <BasicTooltip
      content={readonly ? "Dragging disabled in read-only mode" : "Drag to reorder messages"}
    >
      <div
        {...(dragHandleProps || {})}
        className={`flex h-7 w-5 items-center justify-center rounded-md transition-all duration-150 ease-out hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${
          readonly
            ? "cursor-not-allowed opacity-30"
            : "cursor-grab active:cursor-grabbing active:bg-gray-200"
        }`}
        role="button"
        tabIndex={readonly ? -1 : 0}
        aria-label={`Drag handle for placeholder message ${index + 1}`}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.currentTarget.focus();
          }
        }}
      >
        <GripVertical
          height={14}
          width={14}
          className={
            readonly ? "text-gray-300" : "text-gray-500 transition-colors hover:text-gray-700"
          }
          aria-hidden="true"
        />
      </div>
    </BasicTooltip>
  );
});
